import { api } from 'utils/apis/api';
export const messagingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        readApps: builder.query({
            query: () => ({
                version: 1,
                path: 'messaging/apps',
            }),
        }),
        readIntegrations: builder.query({
            query: ({ appId }) => ({
                version: 1,
                path: `messaging/apps/${appId}/integrations`,
            }),
        }),
    }),
});
